export default "__VITE_ASSET__CbzO9YP6__"